import "./App.css";
import SignIn from "./Components/SignIn";
import SignUp from "./Components/SignUp";
import WizardStepOne from "./Components/WizardStepOne";
import WizardStepTwo from "./Components/WizardStepTwo";
import WizardStepThree from "./Components/WizardStepThree";
import Overview from "./Components/Overview/Overview";
import Categories from "./Components/Categories/Categories";
import Statistics from "./Components/Statistics/Statistics";
import Container from "@material-ui/core/Container";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { DataProvider } from "./Context/Context";

function App() {
  return (
    <div className="App">
      <DataProvider>
        <BrowserRouter>
          <Container maxWidth="sm">
            <Switch>
              <Route path="/" exact component={SignIn} />
              <Route path="/signup" component={SignUp} />
              <Route path="/wizardstepone" component={WizardStepOne} />
              <Route path="/wizardsteptwo" component={WizardStepTwo} />
              <Route path="/wizardstepthree" component={WizardStepThree} />

              <Route path="/overview" component={Overview} />
              <Route path="/categories" component={Categories} />
              <Route path="/statistics" component={Statistics} />
            </Switch>
          </Container>
        </BrowserRouter>
      </DataProvider>
    </div>
  );
}

export default App;
